import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Title = styled.h1`
  font-size: 24px;
  font-weight: normal;
  color: ${props => props.theme.PRIMARY};
`;

function PageTitle({ title }) {
  return <Title id={`PageTitle.${title}`}>{title}</Title>;
}

PageTitle.propTypes = {
  title: PropTypes.string.isRequired,
};

export default PageTitle;
